import SharedDialogBase from 'shared/components/dialog-base/dialog-base';

interface ICustomerAlertNotesDialog {
  notes: string[];
}

const CustomerAlertNotesDialog = ({ notes }: ICustomerAlertNotesDialog) => {
  const customContent = () => {
    return (
      <div className='p-4 overflow-y-auto'>
        <p className='mb-3'>An alert exists on this customer record:</p>
        {notes.map((note) => (
          <p className='font-semibold pb-4 last:pb-0 border-t pt-3 body-01 whitespace-pre-wrap' key={note}>
            {note}
          </p>
        ))}
      </div>
    );
  };

  return <SharedDialogBase title='Alert' customContentTemplate={customContent()} />;
};

export default CustomerAlertNotesDialog;
